export default __webpack_public_path__ + "media/zurb/img/events/wired/second-harvest/harvest-img2-c75656d5a77a210d9827bad13e365b33.jpg";